'use strict';

var angular = require('angular');

function isLocalDevHost(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

var RedirectToReactController = /*@ngInject*/ function (
  $scope,
  $stateParams,
  $window,
  LegacyRedirectService,
  ReactNavigationService
) {
  var _self = this;
  var $html = angular.element(document.documentElement);

  _self.message = '';
  _self.originalUrl = '';
  _self.reactRedirectUrl = '';
  _self.showLink = false;

  _self.goNow = function () {
    LegacyRedirectService.goNow();
  };

  var syncUrls = function () {
    _self.originalUrl = $stateParams.from || '';
    _self.reactRedirectUrl = ReactNavigationService.buildUrl(
      ReactNavigationService.getReactPath($stateParams.target, $stateParams)
    );
  };

  var syncView = function () {
    var ui = LegacyRedirectService.ui;

    if (ui.manualOnly) {
      _self.showLink = true;
      _self.message =
        "You've landed on a page that does not exist in this app. " +
        'Use the link below to redirect to the new ICON.1 app.';
      return;
    }

    _self.showLink = false;

    if (ui.secondsRemaining > 0) {
      _self.message =
        'Redirecting to the new ICON.1 app in ' +
        ui.secondsRemaining +
        ' seconds...';
    }
  };

  var activate = function () {
    var options = {};

    if (isLocalDevHost($window.location.hostname) && !$stateParams.autoRedirect) {
      options.manualOnly = true;
    }

    syncUrls();
    LegacyRedirectService.start($stateParams.target, $stateParams, options);
    syncView();
  };

  $html.addClass('gbip-redirect-page');

  activate();

  $scope.$on('$destroy', function () {
    $html.removeClass('gbip-redirect-page');
  });

  $scope.$watch(function () {
    return LegacyRedirectService.ui.manualOnly;
  }, syncView);

  $scope.$watch(function () {
    return LegacyRedirectService.ui.secondsRemaining;
  }, syncView);

  $scope.$on('$stateChangeSuccess', function (event, toState) {
    if (toState.name === 'redirect-to-react') {
      activate();
    }
  });
};

module.exports = RedirectToReactController;
